import React from 'react';

import InfoItem from 'flow/components/tickets/ticket-info-section/contact-info/InfoItem';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectMembersCount } from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';

interface Props {
    ticketKey: TicketKey;
}

/**
 * The row the access field replaces, kept for as long as the access dialog is
 * held back by its flag. It is the only way into the members dialog, so without
 * it membership has no UI at all.
 */
const TicketMembersInfoItem = ({ ticketKey }: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    const membersCount = useAppSelector((state) =>
        selectMembersCount(state, ticketKey),
    );

    return (
        <InfoItem
            primaryText={i18next.t('chatsettings.members')}
            secondaryText={membersCount}
            handleNavigate={() => openModal('ticketMembers', { ticketKey })}
        />
    );
};

export default React.memo(TicketMembersInfoItem);
